import React from "react";

const Pillar = ({ pillarArray }) => {
  return (
    <div
      className={`max-w-[250px] ${pillarArray.color} p-4  ${
        pillarArray.id === 1
          ? "md:rounded-l-2xl"
          : pillarArray.id === 4
          ? "md:rounded-r-2xl"
          : ""
      }`}
    >
      <div className="flex flex-col justify-center items-center text-white gap-3">
        <p className="text-7xl my-4 font-bold">{pillarArray?.letter}</p>
        <p className="text-2xl font-semibold mb-0">{pillarArray?.topic}</p>
        <div className="border-t-[3px] w-1/2 border-white"></div>
        <p className="text-center text-base">{pillarArray?.description}</p>
      </div>
    </div>
  );
};

export default Pillar;
